module.exports = __webpack_public_path__ + "img/2025-05-09c_5.6c7258b8.jpg";